import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WeathermapTokenService {
  token = signal(null);
  token$ = toObservable(this.token);

  constructor(private readonly httpCLient: HttpClient) {}

  fetchToken(): void {
    this.httpCLient.get<{body: string}>(`${environment.authUrl}weathermap/token`)
      .subscribe(response => {
        this.token.set(response.body);
      });
  }
}
